import AutomationPostModalHeader from './AutomationPostModalHeader';

export default AutomationPostModalHeader;
